import { render } from "./OrganizationMemberList.vue?vue&type=template&id=38c2c523"
import script from "./OrganizationMemberList.vue?vue&type=script&lang=js"
export * from "./OrganizationMemberList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__